import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select'; 
import { getAllDocuments } from '../../../client/seasonDocumentSuppliers';
import { searchSuppliersByName } from '../../../client/suppliers';

const RequirementsAdminFilters = ({
  applyFilters,
  activeFilters = {},
  resetFlag,
  position = "md:right-0 right-auto",
  seasonId,
  selectedDocuments = [],
  setSelectedDocuments,
  selectedSuppliers = [],
  setSelectedSuppliers
}) => {

  const [showFilters, setShowFilters] = useState(false);
  const [loadingDocuments, setLoadingDocuments] = useState(false);
  const [documentsOptions, setDocumentsOptions] = useState([]);

  const [supplierOptions, setSupplierOptions] = useState([]);
  const [loadingSuppliers, setLoadingSuppliers] = useState(false);

  const filterRef = useRef(null);

  useEffect(() => {
    if (resetFlag && setSelectedDocuments && setSelectedSuppliers) {
      setSelectedDocuments([]);
      setSelectedSuppliers([]);
    }
  }, [resetFlag, setSelectedDocuments, setSelectedSuppliers]);

  useEffect(() => {
    if (seasonId) {
      fetchDocuments();
    } else {
      setDocumentsOptions([]);
      setSupplierOptions([]);
    }
  }, [seasonId, resetFlag]);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showFilters && 
          filterRef.current && 
          !filterRef.current.contains(event.target) &&
          !event.target.closest('button[class*="border-blue-light"]')) {
        setShowFilters(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilters]);

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '40px',
      maxHeight: '120px',
      overflow: 'auto',
      borderColor: '#D1D5DB',
      '&:hover': { borderColor: '#D1D5DB' },
      boxShadow: state.isFocused ? 'none' : base.boxShadow,
      fontFamily: 'ITC-book, sans-serif',
      fontSize: '14px'
    }),
    menu: (base) => ({
      ...base,
      position: 'absolute',
      zIndex: 9999,
      marginTop: '4px',
      width: '100%',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      fontFamily: 'ITC-book, sans-serif', 
      fontSize: '14px'
    }),
    menuPortal: base => ({
      ...base,
      zIndex: 9999,
      fontFamily: 'ITC-book, sans-serif',
      fontSize: '14px'
    }),
  input: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  singleValue: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  multiValue: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  multiValueLabel: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  placeholder: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  option: (base) => ({
    ...base,
    fontFamily: 'ITC-book, sans-serif',
    fontSize: '14px'
  }),
  };

  const fetchSuppliers = async (searchTerm = "") => {
    try {
      setLoadingSuppliers(true);

      const limit = searchTerm.trim() === "" ? 5 : 20;
      
      const response = await searchSuppliersByName(searchTerm, limit, seasonId);

      const suppliers = Array.isArray(response.data)
        ? response.data.map((s) => ({
            value: s.id.toString(),
            label: `${s.name} - ${s.code}`,
          }))
        : [];

      setSupplierOptions(suppliers);
    } catch (error) {
      console.error("❌ Error al cargar proveedores:", error);
    } finally {
      setLoadingSuppliers(false);
    }
  };

  const handleSupplierChange = (selectedOptions) => {
    setSelectedSuppliers(selectedOptions);

  };

  useEffect(() => {
    if (resetFlag) {
      setSelectedDocuments([]);
    }
  }, [resetFlag]);

  const fetchDocuments = async () => {
    setLoadingDocuments(true);
    try {
      const params = {
        includeDeleted: false,
      };
      
      if (seasonId) {
        params.seasonId = seasonId;
      }
      
      const response = await getAllDocuments(params);
      
      const options = response.data.map(doc => ({
        value: doc.id,
        label: doc.name,
      }));
      
      setDocumentsOptions(options);
    } catch (error) {
      console.error('Error al cargar documentos:', error);
    } finally {
      setLoadingDocuments(false);
    }
  };

  const handleDocumentsChange = (selectedOptions) => {
    setSelectedDocuments(selectedOptions || []);
  };
  
  const toggleFilters = () => setShowFilters(!showFilters);

  const handleApplyFilters = () => {
    const filtersToApply = {
      documentIds: selectedDocuments.map(doc => doc.value),
      supplierIds: selectedSuppliers.map(sup => parseInt(sup.value))
    };

    applyFilters(filtersToApply);
    setShowFilters(false);
  };


  const hasActiveFilters = () => {
    return selectedDocuments.length > 0 || selectedSuppliers.length > 0;
  };

  return (
    <div className='relative' ref={filterRef}>
      <button
        onClick={toggleFilters}
        className={`flex items-center justify-center font-itcbook px-2 w-[105px] border-blue-light text-sm border-[1px] h-[40px] rounded-lg ${
          hasActiveFilters() 
            ? 'bg-blue-light text-white' 
            : 'bg-transparent text-[#6B7280]'
        }`}
        disabled={!seasonId}
      >
        Filtrar por
      </button>
      
      {showFilters && (
        <div
          onClick={(e) => e.stopPropagation()}
          className={`md:p-4 p-4 md:px-5 bg-white absolute ${position} top-12 overflow-y-auto max-h-[400px] md:max-h-[450px] rounded-lg w-[266px] sm:w-[372px] z-10 shadow-[0px_1px_3px_0px_#0000004D,0px_4px_8px_3px_#00000026]`}
        >
          <div className='flex flex-col gap-3'>
            <p className='text-base text-blue font-itcbold'>Filtrar por</p>
            <div className='w-full h-[1px] md:my-2 bg-[#D9D9D9]'></div>

                <div className='flex flex-col gap-2'>
                    <p className='text-sm md:text-base text-blue font-itcbook'>
                    Documentos:
                    </p>
                    <Select
                    isMulti
                    isLoading={loadingDocuments}
                    isDisabled={loadingDocuments}
                    options={documentsOptions}
                    value={selectedDocuments}
                    onChange={handleDocumentsChange}
                    placeholder={loadingDocuments ? "Cargando..." : "Seleccione documentos"}
                    className="text-sm font-itcbook"
                    noOptionsMessage={() => "No hay opciones disponibles"}
                    styles={selectStyles}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    />
                </div>

                <div className='flex flex-col gap-2'>
                    <p className='text-sm md:text-base text-blue font-itcbook'>
                    Proveedores:
                    </p>
                    <Select
                    isMulti
                    isLoading={loadingSuppliers}
                    options={supplierOptions}
                    value={selectedSuppliers}
                    onChange={handleSupplierChange}
                    placeholder={loadingSuppliers ? "Cargando..." : "Seleccione proveedores"}
                    className="text-sm font-itcbook"
                    noOptionsMessage={({ inputValue }) => {
                    if (inputValue.length === 0) {
                        return "Escribe para buscar proveedores...";
                    }
                    if (inputValue.length < 2) {
                        return "Escribe al menos 2 caracteres";
                    }
                    return "No se encontraron proveedores";
                    }}
                    styles={selectStyles}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    onInputChange={(inputValue) => {
                        if (inputValue.length >= 2 || inputValue === "") {
                          fetchSuppliers(inputValue); 
                        }
                      }}
                    />
                </div>

            <div className="flex justify-center w-full pt-6">
              <button
                onClick={handleApplyFilters}
                className="underline text-blue font-itcbold"
              >
                Aplicar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RequirementsAdminFilters;